import { createBrowserRouter } from "react-router-dom";
import {
  Main,
  Home,
  EyeCareDetails,
  EyeCareInternal,
  Blog,
  Blogs,
  ContactUs,
  Doctors,
  HealthCheckup,
  WaveLightPlus,
  NotFoundPage,
  Doctorsdetails,
} from "views";

export const departmentConstants = {
  OPTHOMOLOGY: "opthomology",
  ORTHO: "ortho",
  PEDIATRICS: "pediatrics",
  GYNO: "gyno",
  DERMA: "dermatology",
  INTERNAL_MEDICINE: "internalMedicine",
  DIBETOLOGY: "diabetology",
  GEN_SURGERY: "generalSurgery",
  ENT: "ent",
  CARDIO: "cardiology",
  NEPHRO: "nephrology",
  NEURO: "neurology",
  PHYSIO: "physiotherapy",
  GASTRO: "gastroenterology",
  RADIO: "radiology",
  CC: "criticalCare",
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Main />,
    children: [
      {
        element: <Home />,
        index: true, 
      },
      {
        path: "department/:departmentId",
        element: <EyeCareDetails />,
      },
      {
        path: "department-internal/ophthalmology/wavelight-plus",
        element: <WaveLightPlus />,
      },
      {
        path: "department-internal/:departId/:id",
        element: <EyeCareInternal />,
      },
      {
        path: "our-doctor",
        element: <Doctors doctorView />,
      },
       {
        path: "Doctors/:slug",
        element: <Doctorsdetails />,
      },
      {
        path: "blog",
        element: <Blogs />,
      },
      {
        path: "blog/:slug",
        element: <Blog />,
      },
      {
        path: "contact",
        element: <ContactUs />,
      },
      {
        path: "health-checkup",
        element: <HealthCheckup />,
      },
      {
        path: "waveLight-plus",
        element: <WaveLightPlus />,
      },
      {
        path: "wavelight-plus",
        element: <WaveLightPlus />,
      },
      {
        path: "404",
        element: <NotFoundPage />, 
      },
    ],
  },
]);

export default router;
